<template>
  <div class="cat-wrapper">
    <div class="cat">
      <h5 class="cat-title">
        <img :src="textimage" alt="alt">
      </h5>
      <p class="cat-catch">
        {{catchcopy}}
      </p>
      <p class="cat-text">
        {{text}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'workCat',
  props: {
    textimage: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: ''
    },
    catchcopy: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
.cat-wrapper {
  max-width: 840px;
  width: 100%;
  margin: 0 auto;
  margin-top: 70px;
}
.cat-title {
  img {
    height: 40px;
    @media print,screen and (max-width: 767px) {
      height: 20px;
    }
  }
}
.cat-catch {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  border-bottom: 5px dotted #3fae00;
  @media print,screen and (max-width: 767px) {
    font-size: 18px;
  }
}
.cat-text {
  color: #fff;
  font-size: 15px;
}
</style>